// extracted by mini-css-extract-plugin
export default {"responsive":"Navigation_responsive__a-82j"};